import React from "react"
import styled from "styled-components"
import { AngleLeftIcon } from "client/components"

interface ArrowProps {
    isExpanded: boolean
}
interface SubItemWrapperProps {
    isExpanded: boolean
    childrenLength: number
}

const subItemHeight = 36

export const MenuItem = styled.div<{
    isActive: boolean
}>`
    display: flex;
    flex-shrink: 0;
    height: 50px;
    border-top: 1px solid ${(props) => props.theme.menuItemBorderTopColor};
    border-bottom: 1px solid ${(props) => props.theme.menuItemBorderBottomColor};
    background: ${(props) => (props.isActive
        ? props.theme.menuItemActiveBackground
        : props.theme.menuItemBackground)};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        background: ${(props) => (props.isActive
        ? props.theme.menuItemActiveBackground
        : props.theme.menuItemHoverBackground)};
        transition: ${(props) => props.theme.defaultTransition};
    }

    & > a {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 0px 12px 0px 20px;
        user-select: none;
        cursor: pointer;
        font-size: ${(props) => props.theme.fontSizes.md}px;
        font-family: ${(props) => props.theme.openSans};
        color: ${(props) => props.theme.menuItemColor};

        &:hover {
            color: ${(props) => props.theme.menuItemColor};
            text-decoration: none;
        }
    }
`
export const MenuSubItemWrapper = styled.div<SubItemWrapperProps>`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    height: ${(props) => (props.isExpanded
        ? props.childrenLength * subItemHeight
        : 0)}px;
    overflow: hidden;
    transition: ${(props) => {
        const delay = props.childrenLength * 0.15
        return (delay > 0.5) ? 0.5 : delay
    }}s ease;
`
export const MenuSubItem = styled.div<{
    isActive: boolean
}>`
    display: flex;
    flex-shrink: 0;
    height: ${subItemHeight}px;
    background: ${(props) => (props.isActive
        ? props.theme.menuSubItemActiveBackground
        : props.theme.menuSubItemBackground)};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        background: ${(props) => (props.isActive
        ? props.theme.menuSubItemActiveBackground
        : props.theme.menuSubItemHoverBackground)};
        transition: ${(props) => props.theme.defaultTransition};
    }

    & > a {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 0px 12px 0px 40px;
        user-select: none;
        cursor: pointer;
        font-size: ${(props) => props.theme.fontSizes.sm}px;
        font-family: ${(props) => props.theme.openSans};
        color: ${(props) => props.theme.menuSubItemColor};

        &:hover {
            color: ${(props) => props.theme.menuSubItemColor};
            text-decoration: none;
        }
    }
`
export const MenuItemTitle = styled.span`
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`

const MenuItemArrowWrapper = styled.span<ArrowProps>`
    width: 15px;
    color: grey;

    & > i {
        transform: rotate(${(props) => (props.isExpanded ? -90 : 0)}deg);
        transition: ${(props) => props.theme.defaultTransition};
    }
`
export const MenuItemArrow = ({
    isExpanded = false,
}: ArrowProps) => (
    <MenuItemArrowWrapper isExpanded={isExpanded}>
        <AngleLeftIcon />
    </MenuItemArrowWrapper>
)
